import moment from 'moment'

export default (date) => {
  return moment().startOf('day').isSameOrBefore(date)
}
